export const newsData = [
  {
    id: 1,
    date: '2024.12.15',
    category: '新商品',
    title: 'ミドル世代向け新商品「エナジーサポートプラス」を発売開始',
    excerpt: '30代から50代の忙しいビジネスパーソンのために開発された、疲労回復と集中力向上をサポートする新しいサプリメントです。',
  },
  {
    id: 2,
    date: '2024.12.01',
    category: 'お知らせ',
    title: '年末年始の営業時間のご案内',
    excerpt: '2024年12月29日から2025年1月5日まで年末年始休業とさせていただきます。ご不便をおかけいたしますが、何卒ご了承ください。',
  },
  {
    id: 3,
    date: '2024.11.20',
    category: 'メディア',
    title: '健康情報誌「ヘルスライフ」に当社製品が掲載されました',
    excerpt: 'シニア世代向けサプリメント「アクティブシニアサポート」が、健康情報誌で高評価をいただきました。',
  },
  {
    id: 4,
    date: '2024.11.10',
    category: 'イベント',
    title: '岡山健康フェア2024に出展いたしました',
    excerpt: '11月9日・10日に開催された岡山健康フェアにて、多くのお客様に当社製品をご体験いただきました。ご来場ありがとうございました。',
  },
];